import React, { createContext, useContext } from "react";

const InitialDataContext = createContext({});

export function InitialDataProvider({ children, initialData }) {
  return (
    <InitialDataContext.Provider value={initialData || {}}>
      {children}
    </InitialDataContext.Provider>
  );
}

export function useInitialData() {
  const context = useContext(InitialDataContext);

  if (context && Object.keys(context).length > 0) {
    return context;
  }

  if (typeof window !== "undefined" && window.__INITIAL_DATA__) {
    return window.__INITIAL_DATA__;
  }

  return {};
}
